export default {
  LIST_FETCHED: 'LEGIS_CLUB_FUELS_FETCHED',
  LIST_LOAD: 'LEGIS_CLUB_FUELS_LOAD',
  LIST_PER_USER_FETCHED: 'LEGIS_CLUB_USER_VOUCHERS_FETCHED',
  LIST_PER_USER_LOAD: 'LEGIS_CLUB_USER_VOUCHERS_LOAD',
  ITEM_DETAIL: 'LEGIS_CLUB_FUELS_DETAIL',
  BUTTON_LOAD: 'LEGIS_CLUB_FUELS_BUTTON_LOAD',
};
